<!--新增行号-->
<template>
  <e-dialog
    dialog-title="选择银行"
    :center-dialog-visible="visible"
    :close-model="false"
    :popup-width="'580px'"
    @resetPopupData="handleCancel"
    @submitPopupData="handleConfirm"
  >
    <div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="">
          <el-input
            v-model="searchForm.bankNumber"
            clearable
            placeholder="请输入银行行号"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="searchForm.bankName"
            clearable
            placeholder="请输入银行名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <TableList
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        max-height="240"
        row-key="bankNumber"
        @handleRowClick="handleSingleElection"
      >
        <template #radio="slot">
          <el-radio
            v-model="templateSelection.bankNumber"
            class="radio"
            :label="slot.scope.row.bankNumber"
            >&nbsp;</el-radio
          >
        </template>
      </TableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, prev, pager, next"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          :pager-count="5"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </e-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import TableList from '../../../components/common/e-table-list';
import EDialog from '../../../components/common/e-dialog.vue';

export default {
  name: 'AddAndUpdateBankSeries',
  components: {
    TableList,
    EDialog,
  },
  data() {
    return {
      loading: false,
      visible: false,
      searchForm: {
        bankName: '',
        bankNumber: '',
      },
      templateSelection: {
        bankNumber: '',
        bankName: '',
      },
      tableData: [],
      tableLabel: [
        {
          label: '',
          param: '',
          align: 'center',
          minWidth: '50',
          slot: 'radio',
        },
        {
          label: '银行行号',
          param: 'bankNumber',
          align: 'center',
          minWidth: '200',
        },
        {
          label: '银行名称',
          param: 'bankName',
          align: 'center',
          minWidth: '200',
        },
      ],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  created() {},

  methods: {
    initData() {
      this.visible = true;
      this.getBankList();
    },
    handleSearch() {
      this.pagination.pageNum = 1;
      this.pagination.pageSize = 10;
      this.getBankList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1;
      this.getBankList();
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getBankList();
    },
    handleSingleElection(row) {
      this.templateSelection = row;
    },
    handleConfirm() {
      this.visible = false;
      this.$emit('confirm', this.templateSelection);
    },
    handleCancel() {
      this.visible = false;
      this.templateSelection = {};
    },
    async getBankList() {
      this.loading = true;
      const res = await Api.queryBankPage({
        bankName: this.searchForm.bankName,
        bankNumber: this.searchForm.bankNumber,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      }).finally(() => {
        this.loading = false;
      });
      if (res.code === '200') {
        this.tableData = res.data.records;
        this.pagination.pageTotal = res.data.total;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
